import axios from 'axios';
import { API_URL, REFRESH_ROUTE } from './consts';
import { readStoredAuthTokens } from '../utils/authStorage';

export const AUTH_SESSION_EXPIRED_EVENT = 'auth:session-expired';
export const AUTH_SESSION_REFRESHED_EVENT = 'auth:session-refreshed';

export const axiosPublicInstance = axios.create({
  baseURL: API_URL,
  timeout: 100000,
  headers: { 'Content-Type': 'application/json;charset=UTF-8', 'Accept': 'application/json, text/plain' },
});

export const axiosInstance = axios.create({
  baseURL: API_URL,
  timeout: 100000,
  headers: { 'Content-Type': 'application/json;charset=UTF-8', 'Accept': 'application/json, text/plain' },
  withCredentials: true,
});

axiosInstance.interceptors.response.use(
  response => response,
  async error => {
    const originalRequest = error.config;
    if ((error?.response?.status === 401 || error?.response?.status === 403) && !originalRequest._retry) {
      originalRequest._retry = true;
      try {
        const storedTokens = readStoredAuthTokens();
        const refreshToken = storedTokens?.refresh ?? undefined;
        const refreshPayload = refreshToken ? { refresh: refreshToken } : {};
        const refreshResponse = await axios.post(`${API_URL}${REFRESH_ROUTE}`, refreshPayload, { withCredentials: true });
        const newAccessToken = refreshResponse?.data?.access;
        if (newAccessToken) {
          axiosInstance.defaults.headers.common['Authorization'] = `Bearer ${newAccessToken}`;
          if (originalRequest.headers) {
            originalRequest.headers['Authorization'] = `Bearer ${newAccessToken}`;
          } else {
            originalRequest.headers = { Authorization: `Bearer ${newAccessToken}` };
          }
          window.dispatchEvent(new CustomEvent(AUTH_SESSION_REFRESHED_EVENT, {
            detail: { access: newAccessToken, refresh: refreshResponse?.data?.refresh },
          }));
        }
        return axiosInstance(originalRequest);
      } catch (refreshError) {
        const status = (refreshError as { response?: { status?: number } })?.response?.status;
        if (status === 401 || status === 403) {
          delete axiosInstance.defaults.headers.common['Authorization'];
          window.dispatchEvent(new Event(AUTH_SESSION_EXPIRED_EVENT));
        }
        return Promise.reject(error);
      }
    }
    return Promise.reject(error);
  }
);
